export default () => ({
  componentName: 'cell-bool',
});
